module.exports = __webpack_public_path__ + "static/media/aisc-white.f7e5f144.png";